module.exports = __webpack_public_path__ + "static/media/IMG-20180129-WA0005.a69b5c2b.jpg";